import React, { useState } from 'react';
import Icon from '../AppIcon';

const FileTreeItem = ({ item, level = 0, selectedFile, onFileSelect }) => {
  const [isExpanded, setIsExpanded] = useState(level === 0);
  const isFolder = item?.type === 'folder';
  const isSelected = selectedFile === item?.path;

  const handleClick = () => {
    if (isFolder) {
      setIsExpanded(!isExpanded);
    } else {
      onFileSelect(item);
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' || e?.key === ' ') {
      e?.preventDefault();
      handleClick();
    } else if (isFolder) {
      if (e?.key === 'ArrowRight' && !isExpanded) {
        setIsExpanded(true);
      } else if (e?.key === 'ArrowLeft' && isExpanded) {
        setIsExpanded(false);
      }
    }
  };

  return (
    <div>
      <div
        className={`file-tree-item ${isFolder ? 'folder' : ''} ${isSelected ? 'selected' : ''}`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-expanded={isFolder ? isExpanded : undefined}
        style={{ paddingLeft: `${level * 1.5 + 0.75}rem` }}
      >
        {isFolder && (
          <Icon
            name={isExpanded ? 'ChevronDown' : 'ChevronRight'}
            size={16}
            className="flex-shrink-0"
          />
        )}
        <Icon
          name={isFolder ? (isExpanded ? 'FolderOpen' : 'Folder') : 'File'}
          size={16}
          className="flex-shrink-0"
        />
        <span className="truncate">{item?.name}</span>
      </div>
      {isFolder && isExpanded && item?.children && (
        <div className="file-tree-nested">
          {item?.children?.map((child, index) => (
            <FileTreeItem
              key={`${child?.path}-${index}`}
              item={child}
              level={level + 1}
              selectedFile={selectedFile}
              onFileSelect={onFileSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const FileTreeNavigation = ({ projectStructure, selectedFile, onFileSelect }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filterTree = (items, query) => {
    if (!query) return items;

    return items?.reduce((acc, item) => {
      if (item?.type === 'folder' && item?.children) {
        const filteredChildren = filterTree(item?.children, query);
        if (filteredChildren?.length > 0) {
          acc?.push({ ...item, children: filteredChildren });
        }
      } else if (item?.name?.toLowerCase()?.includes(query?.toLowerCase())) {
        acc?.push(item);
      }
      return acc;
    }, []);
  };

  const filteredStructure = filterTree(projectStructure, searchQuery);

  return (
    <div className="file-tree-container scrollbar-thin">
      <div className="mb-4">
        <div className="relative">
          <Icon
            name="Search"
            size={16}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
          />
          <input
            type="text"
            placeholder="Search files..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="w-full pl-10 pr-4 py-2 bg-muted border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
      </div>
      <div className="space-y-1">
        {filteredStructure?.length > 0 ? (
          filteredStructure?.map((item, index) => (
            <FileTreeItem
              key={`${item?.path}-${index}`}
              item={item}
              selectedFile={selectedFile}
              onFileSelect={onFileSelect}
            />
          ))
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="FileSearch" size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No files found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileTreeNavigation;